export const DEFAULT_META_TITLE =
  'Pickup drop parcels, courier delivery service from Porter';

export const DEFAULT_META_DESCRIPTION =
  'Send packages and get it delivered right at your doorstep. On-demand, hyperlocal online delivery service anywhere in you city. Get a 2 wheeler in 15 mins.';

export const SSR_PILLAR_KEYWORD = 'default';

export const OTHER_SERVICES_TITLE = 'Other Services to Choose From';

export const ARROW_ICON_SRC =
  'https://dom-content-vault-prod-cdn-assets.porter.in/right_arrow_db54b8ed6d/right_arrow_db54b8ed6d.svg';

export const ARROW_ICON_ALT = 'arrow icon';

export const KNOW_MORE = 'Know More';

export const PAYMENT_STATUS_QUERY_KEY = 'status';
export const AMOUNT_QUERY_KEY = 'amount';

export const PNM_MICROSITE_LANDED_EVENT = 'pnmmicrosite_landed';
export const PNM_QUOTE_1_EVENT = 'pnmmicrosite_quote1_clicked';
export const PNM_QUOTE_2_EVENT = 'pnmmicrosite_quote2_clicked';
export const PNM_TNC_EVENT = 'pnmmicrosite_tnc_clicked';
export const PNM_ENTRY_EVENT = 'micrositeimage_clicked';
export const PNM_TESTIMONIAL_SCROLLED_EVENT =
  'pnmmicrosite_testimonial_scrolled';

export const PNM_REQUIREMENT_TYPE = 'houseshifting';
